<template>
  <div>
    <v-text-field
      v-if="detail"
      label="Porcentaje"
      dense
      outlined
      v-model="percentageModel"
    />
    <v-row class="ma-0">
      <div style="display:flex;">
        <span :style="detail ? 'font-size:18px;' : 'font-size:16px;'" style="margin:auto;">
          {{ type }}
        </span>
      </div>
      <v-spacer/>
      <div :style="detail ? 'line-height:20px;' : 'line-height:14px;'">
        <span v-if="detail" style="font-weight:600;" :style="current_grams>grams ? 'color:red;' : ''">
          {{ current_grams.toFixed(2) }}/
        </span>
        <span :style="detail ? 'font-size:14px;' : 'font-size:12px;'">
          {{ grams.toFixed(2) }} g
        </span>
        <br/>
        <span :style="detail ? 'font-size:14px;' : 'font-size:12px;'">
          {{ detail ? (current_calories.toFixed(2) + ' / ') : '' }}{{ calories.toFixed(2) }} Kcal
        </span>
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    calc: Object,
    meal_plan_time: Object,
    type: String,       // 'lp' | 'ps' | 'hc'
    detail: Boolean,
    time: Object
  },

  methods: {
    clacGrams(item) {
      return Number(item.quantity) || 0
    }
  },

  computed: {
    keyForType() {
      switch (this.type) {
        case 'lp': return 'l_percentage'
        case 'ps': return 'p_percentage'
        case 'hc': return 'h_percentage'
        default:   return 'percentage'
      }
    },

    percentageModel: {
      get() {
        if (!this.time) return 0
        const k = this.keyForType
        const v = this.time[k]
        return v != null ? Number(v) : Number(this.time.percentage || 0)
      },
      set(val) {
        const k = this.keyForType
        if (!this.time) this.time = {}
        this.$set(this.time, k, Number(val) || 0)
      }
    },

    // kcal objetivo para este macro en esta "time"
    calories() {
      const totalKcal = Number(this.calc && this.calc.kilocalorias) || 0
      const typePct   = Number(this.calc && this.calc[this.type]) || 0   // % del reparto base
      const timePct   = this.percentageModel || 0                        // % para esta "time"
      return totalKcal * (typePct / 100) * (timePct / 100)
    },

    // gramos objetivo
    grams() {
      const kcal = this.calories
      if (this.type === 'lp') return kcal / 9
      if (this.type === 'ps') return kcal / 4
      if (this.type === 'hc') return kcal / 4
      return 0
    },

    // kcal consumidas actualmente por macro (4/4/9)
    current_calories() {
      let total = 0
      if (!this.meal_plan_time || !Array.isArray(this.meal_plan_time.foods)) return 0

      this.meal_plan_time.foods.forEach(item => {
        const qty = Number(item.quantity) || 0
        const c = (Number(item.food?.carbohydrates) || 0) * qty
        const p = (Number(item.food?.protein)       || 0) * qty
        const l = (Number(item.food?.lipids)        || 0) * qty

        switch (this.type) {
          case 'hc': total += c * 4; break
          case 'ps': total += p * 4; break
          case 'lp': total += l * 9; break
        }
      })
      return total
    },

    // gramos consumidos actualmente del macro
    current_grams() {
      let total = 0
      if (!this.meal_plan_time || !Array.isArray(this.meal_plan_time.foods)) return 0

      switch (this.type) {
        case 'hc':
          this.meal_plan_time.foods.forEach(item => {
            total += (Number(item.food?.carbohydrates) || 0) * this.clacGrams(item)
          })
          break
        case 'ps':
          this.meal_plan_time.foods.forEach(item => {
            total += (Number(item.food?.protein) || 0) * this.clacGrams(item)
          })
          break
        case 'lp':
          this.meal_plan_time.foods.forEach(item => {
            total += (Number(item.food?.lipids) || 0) * this.clacGrams(item)
          })
          break
      }
      return total
    }
  }
}
</script>
